import Api from 'utils/api'
import i18n from 'utils/i18n'

export const flightSlice = ((set, get) => ({
  flights: [],

  actions: {
    fetchFlights: async (params) => {
      get().actions.startLoading();

      const api = new Api();
      api.getFlights(params)
        .then((response) => {
          set((state) => ({ flights: response.data.flights }));
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    }
  }

}))